/* Imports */
import React from "react"
import { Pagination, PaginationButton } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const PaginationPage = () => {
    const items = [
        {
            title: "Left",
            content: (
                <Pagination justify="left">
                    <PaginationButton icon="chevron-left-solid" disabled />
                    <PaginationButton number={1} active />
                    <PaginationButton number={2} />
                    <PaginationButton number={3} />
                    <PaginationButton number={4} />
                    <PaginationButton number={5} />
                    <PaginationButton more />
                    <PaginationButton number={20} />
                    <PaginationButton fajnyIcon="chevron-right-solid" />
                </Pagination>
            ),
            code: '<Pagination justify="left">\n    <PaginationButton icon="chevron-left-solid" disabled />\n    <PaginationButton number={1} active />\n    <PaginationButton number={2} />\n    <PaginationButton number={3} />\n    <PaginationButton number={4} />\n    <PaginationButton number={5} />\n    <PaginationButton more />\n    <PaginationButton number={20} />\n    <PaginationButton fajnyIcon="chevron-right-solid" />\n</Pagination>',
        },
        {
            title: "Center",
            content: (
                <Pagination justify="center">
                    <PaginationButton icon="chevron-left-solid" disabled />
                    <PaginationButton number={1} active />
                    <PaginationButton number={2} />
                    <PaginationButton number={3} />
                    <PaginationButton number={4} />
                    <PaginationButton number={5} />
                    <PaginationButton more />
                    <PaginationButton number={20} />
                    <PaginationButton fajnyIcon="chevron-right-solid" />
                </Pagination>
            ),
            code: '<Pagination justify="center">\n    <PaginationButton icon="chevron-left-solid" disabled />\n    <PaginationButton number={1} active />\n    <PaginationButton number={2} />\n    <PaginationButton number={3} />\n    <PaginationButton number={4} />\n    <PaginationButton number={5} />\n    <PaginationButton more />\n    <PaginationButton number={20} />\n    <PaginationButton fajnyIcon="chevron-right-solid" />\n</Pagination>',
        },
        {
            title: "Right",
            content: (
                <Pagination justify="right">
                    <PaginationButton icon="chevron-left-solid" disabled />
                    <PaginationButton number={1} active />
                    <PaginationButton number={2} />
                    <PaginationButton number={3} />
                    <PaginationButton number={4} />
                    <PaginationButton number={5} />
                    <PaginationButton more />
                    <PaginationButton number={20} />
                    <PaginationButton fajnyIcon="chevron-right-solid" />
                </Pagination>
            ),
            code: '<Pagination justify="right">\n    <PaginationButton icon="chevron-left-solid" disabled />\n    <PaginationButton number={1} active />\n    <PaginationButton number={2} />\n    <PaginationButton number={3} />\n    <PaginationButton number={4} />\n    <PaginationButton number={5} />\n    <PaginationButton more />\n    <PaginationButton number={20} />\n    <PaginationButton fajnyIcon="chevron-right-solid" />\n</Pagination>',
        },
    ]

    const propsItems = [
        {
            name: "justify (Pagination)",
            type: "String",
            example: "center",
            possible: '"left" | "center" | "right"',
            default: "left",
        },
        {
            name: "number",
            type: "Number",
            example: "4",
        },
        {
            name: "more",
            type: "Boolean",
        },
        {
            name: "icon",
            type: "String",
            example: "arrow-right",
        },
        {
            name: "fajnyIcon",
            type: "String",
            example: "arrow-left-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "active",
            type: "Boolean",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default PaginationPage
